"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchWords = void 0;
var _every = _interopRequireDefault(require("lodash/every"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _get = _interopRequireDefault(require("lodash/get"));
var _identity = _interopRequireDefault(require("lodash/identity"));
var _keys = _interopRequireDefault(require("lodash/keys"));
var _map = _interopRequireDefault(require("lodash/map"));
var _some = _interopRequireDefault(require("lodash/some"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Checks whether all words in query match any field in the doc.
 *
 * @example
 * // returns true
 * matchWords({
 *     query: "amber thr",
 *     doc: {
 *         id: "a1",
 *         path: "one/two/three",
 *         text: "red amber green",
 *     },
 *     fields: ["path", "text"],
 * })
 *
 * @param {Object} o - The object which contains function arguments
 * @param {string} o.query - Query string as typed by the user.
 * @param {Object} o.doc - The object to be searched.
 * @param {Array.<string>} [o.fields] - Specific fields to be searched in the doc object. If not provided, the search is applied to all fields.
 * @returns {boolean} Returns true if any of the fields in doc matches all the words in query. The return is also true when there is no query.
 */
var matchWords = function matchWords(_ref) {
  var query = _ref.query,
    doc = _ref.doc,
    fields = _ref.fields;
  // get non-empty words, without special characters
  var words = (0, _filter["default"])(query.split(/[^a-z0-9]+/i), _identity["default"]);
  if (!words.length) {
    return true;
  }

  // convert each word into regex for case insensitive matching
  words = (0, _map["default"])(words, function (word) {
    return new RegExp(word, "i");
  });

  // match all words on any of the fields
  return (0, _every["default"])(words, function (wordexp) {
    return (0, _some["default"])(fields || (0, _keys["default"])(doc), function (field) {
      var q = typeof field === "function" ? field(doc) : (0, _get["default"])(doc, field);
      return wordexp.test(q);
    });
  });
};
exports.matchWords = matchWords;